import { render, staticRenderFns } from "./envioEmail.vue?vue&type=template&id=bc53e7fe&scoped=true"
import script from "./envioEmail.vue?vue&type=script&lang=js"
export * from "./envioEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc53e7fe",
  null
  
)

export default component.exports